import React from 'react';
import ListsCollapsibleSection from './ListsCollapsibleSection';

/**
 * Sección colapsable "MIS LISTAS".
 * Recibe el listado ya filtrado vía children (las cards las arma el panel por ahora).
 * `toolbar` (Todos / Público / Privado) vive dentro del colapso.
 */
export default function MyListsSection({
  expanded,
  onToggle,
  hasItems,
  emptyContent,
  toolbar = null,
  fillHeight = false,
  children,
}) {
  return (
    <ListsCollapsibleSection
      title="MIS LISTAS"
      expanded={expanded}
      onToggle={onToggle}
      hasItems={hasItems}
      emptyContent={emptyContent}
      toolbar={toolbar}
      fillHeight={fillHeight}
    >
      {children}
    </ListsCollapsibleSection>
  );
}
